// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__H2HDD","load4":"Spinner_load4__eKQiz","isLoginSpinner":"Spinner_isLoginSpinner__N7Onf","rounded":"Spinner_rounded__ygtrX","load8":"Spinner_load8__MoDIZ"};